import { render, staticRenderFns } from "./GroupUploadModal.vue?vue&type=template&id=84a42b24&"
import script from "./GroupUploadModal.vue?vue&type=script&lang=js&"
export * from "./GroupUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports